module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n7r9r3n-c671e29f0b8c2d0af5a21a61fd750eec.svg";